import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import PlusIcon from '../icons/plus-icon';

const Accordion = ({ title, subtitle, children }) => {
  const [isAccordionOpen, setIsAccordion] = useState(false);
  const accordionMenuRef = useRef(null);

  useEffect(() => {
    if (isAccordionOpen) {
      accordionMenuRef.current.style.height = `${accordionMenuRef.current.scrollHeight}px`;
    } else {
      accordionMenuRef.current.style.height = 0;
    }
  }, [isAccordionOpen]);

  const handleAccordion = (e) => {
    e.target.closest('.toggle-button').classList.toggle('opened');
    setIsAccordion((val) => !val);
  };

  return (
    <div className="-mt-[1px] flex flex-col">
      <button
        className="toggle-button relative flex w-full items-center justify-between border-t-[1px] border-[#D9D9D9] py-3.5 text-left text-sm leading-none lg:py-4 lg:text-2xl xl:gap-2 xl:py-6 xl:text-[2rem]"
        type="button"
        onClick={handleAccordion}
      >
        <span {...(subtitle ? { className: 'flex-1' } : {})}>{title}</span>
        {subtitle && (
          <span className="hidden flex-[0_0_11rem] text-xs lg:block lg:text-sm xl:flex-[0_0_14rem] xl:text-lg">
            {subtitle}
          </span>
        )}
        <span className="toggle-icon-plus absolute right-0">
          <PlusIcon
            isMinus={false}
            className="h-[0.75rem] w-[0.75rem] lg:h-[1.15rem] lg:w-[1.15rem]"
          />
        </span>
        <span className="toggle-icon-minus absolute right-0">
          <PlusIcon className="h-[0.75rem] w-[0.75rem] lg:h-[1.15rem] lg:w-[1.15rem]" isMinus />
        </span>
      </button>

      <div className="h-0 overflow-hidden transition-all duration-[.3s]" ref={accordionMenuRef}>
        <div className="space-y-6 py-6 lg:space-y-8 lg:py-10 xl:py-16">{children}</div>
      </div>
    </div>
  );
};

export default Accordion;

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Accordion.defaultProps = {
  subtitle: '',
};
